import { catalogApi } from '@/api/catalog.api';
import { apiErrorMessage } from '@/api/client';
import type { CatalogCategoryModel } from '@/types/catalog.types';
import { useCallback, useEffect, useState } from 'react';

export interface CatalogState {
  categories: CatalogCategoryModel[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/** The category catalogue (`GET /catalog`): labels, colours and tints; loaded once per mount. */
export const useCatalog = (): CatalogState => {
  const [categories, setCategories] = useState<CatalogCategoryModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setCategories(await catalogApi.list());
    } catch (err) {
      setError(apiErrorMessage(err, 'The category catalogue could not be loaded.'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { categories, isLoading, error, refetch };
};
